import { cn } from '@Pages/pageRuntime/lib/utils';
import * as React from 'react';

const AlertDescription = ({
  className,
  ref,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement> & { ref?: React.Ref<HTMLParagraphElement> }) => (
  <div ref={ref} className={cn('text-sm [&_p]:leading-7', className)} {...props} />
);
AlertDescription.displayName = 'AlertDescription';

export { AlertDescription };
